import { QueryKeys } from '../../../enums/queryKeys'
import { QuotesQueryProps } from '../types/quotesQueryProps'

export const getQuotesQueryKey = (queryProps: QuotesQueryProps): [QueryKeys, QuotesQueryProps] => [
  QueryKeys.Quotes,
  queryProps,
]
